<template>
    <div id="closeWeb">
        <h1 class="closeMsg">管理员已关闭网站，请与管理员联系</h1>
    </div>
</template>

<script>
export default {
        components:{

          },
        data() {
          return {
            closeWeb:false,
            loading:false,
          }
        },
        mounted(){

        }
      }
</script>


<style lang="less" scoped>
#closeWeb{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .closeMsg{
        margin-top: 40px;
        color: gray;
    }
}
</style>